import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';

import styles from './SearchFilters.module.scss';

interface ISearchFilterObjectProps {
  filterName: string;
  filterValue: ISelectOption;
  removeFilterValue: () => void;
}

export const SearchFilterObject = ({ filterName, filterValue, removeFilterValue }: ISearchFilterObjectProps) => (
  <div className={styles.FilterWrap}>
    {filterName && <div className={styles.FilterLabel}>{filterName}</div>}
    {filterValue?.label && (
      <div className={styles.FilterTextWrap}>
        <div className={styles.FilterText}>{filterValue.label}</div>
        <div className={styles.FilterRemove} onClick={removeFilterValue} />
      </div>
    )}
  </div>
);
